import { render, staticRenderFns } from "./team_awards.vue?vue&type=template&id=1fdea962&scoped=true&"
import script from "./team_awards.vue?vue&type=script&lang=js&"
export * from "./team_awards.vue?vue&type=script&lang=js&"
import style0 from "./team_awards.vue?vue&type=style&index=0&id=1fdea962&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdea962",
  null
  
)

export default component.exports